import loadScript from 'simple-load-script';
import returnAppConfig from '@/helpers/return-app-config';
import errorHandlers from '@/services/error-handlers';

const getCdnScripts = (gatewayProviders) => {
  const { isProductionEnvironment } = returnAppConfig();

  const cdnMap = {
    Square: 'https://'.concat(!isProductionEnvironment ? 'sandbox.web.squarecdn.com/v1/square.js' : 'web.squarecdn.com/v1/square.js'),
    Stripe: 'https://js.stripe.com/v3/'
  };

  const script = [];

  Object.keys(gatewayProviders).forEach((provider) => {
    if (gatewayProviders[provider].threeDsConfig?.threeDsRequired) {
      script.push(gatewayProviders[provider].threeDsConfig?.threeDsJavascriptUrl);
    }
    else if (cdnMap[provider]) {
      script.push(cdnMap[provider]);
    }
  });

  return script;
};

const loadPaymentSDK = async ({ providers }) => {
  try {
    const [cdnScript = null] = getCdnScripts(providers);

    const promiseArray = [
      cdnScript && loadScript(cdnScript),
      /** Load google pay if not Square */
      !('Square' in providers) && loadScript('https://pay.google.com/gp/p/js/pay.js')
    ];

    await Promise.all(promiseArray);
  }
  catch (e) {
    errorHandlers.silent(e);
  }
};

export default loadPaymentSDK;
